import { OpenAIClient, AzureKeyCredential } from '@azure/openai';

export const openAiClient = new OpenAIClient(
  process.env.REACT_APP_OPEN_AI_ENDPOINT,
  new AzureKeyCredential(
    process.env.REACT_APP_OPEN_AI_KEY
    // (await handler()).Aikey
  )
);
